// extracted by mini-css-extract-plugin
module.exports = {"container":"Modal_container__2NxNj","modal":"Modal_modal__IhhWG","header":"Modal_header__1UAR1","title":"Modal_title__13han","close":"Modal_close__3nhTC"};